// https://github.com/tc39/proposal-observable
require('../internals/define-well-known-symbol')('observable');
